"use client";
//#region packages/@mantine/core/src/core/styles-api/use-styles/get-class-name/get-static-class-names/get-static-class-names.ts
/** Returns static component classes, for example, `.mantine-Input-wrapper` */
function getStaticClassNames({ themeName, classNamesPrefix, selector, withStaticClass }) {
	if (withStaticClass === false) return [];
	return themeName.map((n) => `${classNamesPrefix}-${n}-${selector}`);
}
//#endregion
export { getStaticClassNames };

//# sourceMappingURL=get-static-class-names.mjs.map